"use client";

import { RootState } from "interfaces/generics.type";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import VehicleSelectorForm from "./VehicleSelectorForm";
import { MAKE_YEAR_MODEL, YEAR_MAKE_MODEL } from "./constants";

export function YearNotFitInModel(props) {
  const {
    defaultMake, defaultModel, defaultYear, selectionOrder = YEAR_MAKE_MODEL,
  } = props;

  const [_selectionOrder, setSelectionOrder] = useState(selectionOrder);
  const { currentPageType, syncedProduct } = useSelector((store: RootState) => store.utils);
  const { sku } = syncedProduct || {};

  const [updatedDefaultVehicle, setUpdatedDefaultVehicle] = useState({
    defaultMake,
    defaultModel,
    defaultYear,
  });

  useEffect(() => {
    setUpdatedDefaultVehicle({ defaultMake, defaultModel, defaultYear });
  }, [defaultMake, defaultModel, defaultYear]);

  function yearNotFitInModelHandler(params) {
    const { selectedYear, selectedMake } = params;
    updatedDefaultVehicle.defaultModel = null;
    updatedDefaultVehicle.defaultYear = selectedYear;

    setUpdatedDefaultVehicle({
      defaultMake: selectedMake,
      defaultYear: selectedYear,
      defaultModel: null,
    });
    setSelectionOrder(MAKE_YEAR_MODEL);
  }

  useEffect(() => {
    setSelectionOrder(selectionOrder);
  }, [...selectionOrder]);

  return (
    <VehicleSelectorForm
      {...props}
      {...updatedDefaultVehicle}
      selectionOrder={_selectionOrder}
      yearNotFitInModelHandler={yearNotFitInModelHandler}
      currentPageType={currentPageType}
      sku={sku}
    />
  );
}
